<template>
  <div>
    <v-card class="card--shadow">
      <v-card-text>
        <!-- PATIENT INFO SECTION -->
        <v-row>
          <v-col lg="4">
            <label>Name</label>
            <v-text-field v-model.trim="familyMember.name" type="text" outlined dense></v-text-field>
          </v-col>

          <v-col lg="4">
            <label>Age</label>
            <v-text-field v-model.trim="familyMember.age" type="text" outlined dense></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Sex</label>
            <v-radio-group v-model="familyMember.sex" row>
              <v-radio label="Male" value="1"></v-radio>
              <v-radio label="Female" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="4" >
            <label>Eligible</label>
            <v-radio-group v-model="familyMember.eligible" row>
              <v-radio label="Yes" value="2"></v-radio>
              <v-radio label="No" value="1"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col lg="4" v-if="familyMember.eligible=='1'">
            <label>Reason</label>
            
            <v-text-field v-model.trim="familyMember.reason" type="text" filled dense></v-text-field>
          </v-col>
          <v-col-4>
            <br>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                :loading="loading"
                v-if="familyMember.id"
                @click.prevent="emitData"
                class="form-btn"
              >
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
              </v-btn>
              <v-btn
                :loading="loading"
                v-else
                @click.prevent="emitData"
                class="form-btn"
              >
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
              </v-btn>
              </v-card-actions>
          </v-col-4>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    familyMember: {
      type: Object,
      default: () => {
        return {
          name: null,
          age: null,
          sex: null,
          eligible:'2',
          reason:null,
        };
      }
    }
  },
  methods: {
    emitData() {
      let data = {
        name: this.familyMember.name,
        sex: this.familyMember.sex,
        age: this.familyMember.age,
        patient_id: this.$route.params.patient_id,
        eligible:this.familyMember.eligible,
        reason:this.familyMember.reason
      };

      this.familyMember.id ? (data.id = this.familyMember.id) : false;

      this.$emit("emitData",data);

      if(!this.familyMember.id)
      {
        // Clear the input fields
        this.familyMember = {
          name: '',
          sex: '',
          age: '',
          reason:'',
          eligible:'2',
        };
      }else{
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style>
</style>